import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Text } from '@nerdwallet/currency';
import {
  getDisplayName as getName,
  getProductType,
  isActive,
} from '@nerdwallet/marketplace/selectors/common';
import { PRODUCT_TYPES } from '@nerdwallet/marketplace/constants';
import HtmlToNDS from '@nerdwallet/react-html-to-nds';

import styles from './with-out-of-date-messaging.module.less';

function withOutOfDateMessaging(WrappedComponent) {
  const OutOfDateMessaging = ({ data, dataDependency, ...props }) => {
    // if there is a product matching the given ID that is both a credit card and inactive,
    // add it to the list of inactive products we should include messaging for
    const entities = data?.value ?? [];

    const inactiveEntities = _.filter(
      entities,
      (entity) =>
        getProductType(entity) === PRODUCT_TYPES.CREDIT_CARDS &&
        !isActive(entity)
    );

    const entityNames = inactiveEntities.map(getName);
    const productLanguage =
      inactiveEntities.length > 1 ? 'These products are' : 'This product is';

    const messageText = `Information about the ${entityNames.join(
      ', '
    )} may be out of date. ${productLanguage} not available on NerdWallet.`;

    const message = (
      <div className={styles.withOutOfDateMessaging}>
        <Text size="small">
          {/* The names may include HTML elements */}
          <HtmlToNDS html={messageText} />
        </Text>
      </div>
    );

    return (
      <Fragment>
        {!_.isEmpty(inactiveEntities) ? message : null}
        <WrappedComponent
          data={data}
          dataDependency={dataDependency}
          {...props}
        />
      </Fragment>
    );
  };

  OutOfDateMessaging.propTypes = {
    data: PropTypes.object,
    dataDependency: PropTypes.object,
  };

  OutOfDateMessaging.defaultProps = {
    data: {},
    dataDependency: {},
  };

  OutOfDateMessaging.getEditingConfig = WrappedComponent.getEditingConfig;
  OutOfDateMessaging.isContainer = WrappedComponent.isContainer;
  OutOfDateMessaging.displayName = `withOutOfDateMessaging (${WrappedComponent.displayName})`;

  return OutOfDateMessaging;
}

export default withOutOfDateMessaging;
